var map = {
	"./slide_1_en.svg": "QkP6",
	"./slide_1_fr.svg": "IJ4s",
	"./slide_2_en.svg": "RkJk",
	"./slide_2_fr.svg": "j4q5",
	"./slide_3_en.svg": "ckBf",
	"./slide_3_fr.svg": "8guU",
	"./slide_4_en.svg": "wZ6f",
	"./slide_4_fr.svg": "Q3Kz",
	"./slide_5_en.svg": "Aozc",
	"./slide_5_fr.svg": "Qdlu",
	"./slide_6_en.svg": "YHuX",
	"./slide_6_fr.svg": "4B/y",
	"./slide_7_en.svg": "UCd6",
	"./slide_7_fr.svg": "C5vE",
	"./slide_8_en.svg": "2noi",
	"./slide_8_fr.svg": "UYp5",
	"./slide_9_en.svg": "lQ4+",
	"./slide_9_fr.svg": "DcIV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TaTE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider ^\.\/slide_.*\.svg$
// module id = TaTE
// module chunks = 0